import React from 'react'
import { Link } from 'react-router-dom'
import SeoHead from '../components/SeoHead'
import { SERVICES, COMPANY, IMAGES } from '../data/siteData'
import { PAGE_META } from '../data/metaData'
import { getOptimizedImageUrl } from '../lib/imageHelper'
import CtaBanner from '../components/CtaBanner'

export default function ServicesIndexPage() {
  const metaTitle = PAGE_META.services.title
  const metaDescription = PAGE_META.services.description

  return (
    <div>
      <SeoHead
        title={metaTitle}
        description={metaDescription}
        canonicalPath="/ydelser"
      />

      {/* Header */}
      <section className="relative bg-stone-950 text-white py-16 sm:py-20 overflow-hidden border-b border-stone-800">
        <div className="absolute inset-0 z-0">
          <img
            src={getOptimizedImageUrl(IMAGES.hero, { width: 1800, quality: 80 })}
            alt="JT Knudsen maskinelt anlægs- og gravearbejde med minigraver"
            className="w-full h-full object-cover opacity-60 brightness-95"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-stone-950/80 via-stone-950/50 to-stone-950/20"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-amber-500/20 text-amber-400 text-xs font-bold uppercase tracking-wider mb-3">
              <i className="fa-solid fa-list-check" aria-hidden="true"></i>
              <span>Vores ydelser</span>
            </span>
            <h1 className="text-3xl sm:text-5xl font-extrabold text-white tracking-tight drop-shadow-md">
              Kvalitetsarbejde til bolig, have og byggeri
            </h1>
            <p className="mt-4 text-base sm:text-xl text-stone-200 leading-relaxed drop-shadow-sm">
              <Link to="/" className="text-white font-semibold underline decoration-amber-500 decoration-2 underline-offset-2 hover:text-amber-400 transition-colors">JT Knudsen</Link> udfører mindre entreprenør-, grave- og anlægsopgaver for private og virksomheder. Vi lægger vægt på personlig dialog, ordentligt forarbejde og en gennemskuelig proces.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 sm:py-24 bg-stone-50 text-stone-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-10">
            {SERVICES.map((s, idx) => (
              <div
                key={s.path}
                className="bg-white rounded-2xl border border-stone-200 shadow-sm overflow-hidden flex flex-col justify-between"
              >
                <div>
                  <div className="relative aspect-16/10 overflow-hidden bg-stone-900">
                    <img
                      src={getOptimizedImageUrl(s.image, { width: 800, height: 500 })}
                      alt={`${s.title} udført af JT Knudsen`}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                    <div className="absolute top-4 left-4">
                      <span className="px-3 py-1 rounded-full bg-stone-950/80 backdrop-blur text-amber-400 text-xs font-bold uppercase tracking-wider border border-stone-700">
                        {s.badge}
                      </span>
                    </div>
                  </div>

                  <div className="p-6 sm:p-8">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 rounded-lg bg-amber-500/15 text-amber-600 flex items-center justify-center text-lg shrink-0">
                        <i className={s.icon} aria-hidden="true"></i>
                      </div>
                      <h2 className="text-xl sm:text-2xl font-bold text-stone-900">
                        {s.title}
                      </h2>
                    </div>
                    <p className="text-stone-600 text-sm sm:text-base leading-relaxed">
                      {s.description}
                    </p>
                  </div>
                </div>

                <div className="px-6 sm:px-8 pb-6 sm:pb-8 pt-2 border-t border-stone-100 flex items-center justify-between">
                  <Link
                    to={s.path}
                    className="inline-flex items-center gap-2 text-sm font-bold text-stone-900 hover:text-amber-600 transition-colors"
                  >
                    <span>Læs mere om ydelsen</span>
                    <i className="fa-solid fa-arrow-right text-xs text-amber-500" aria-hidden="true"></i>
                  </Link>

                  <a
                    href={COMPANY.phoneHref}
                    className="text-xs text-stone-500 hover:text-stone-900 font-semibold whitespace-nowrap"
                  >
                    Tlf. {COMPANY.phone}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <CtaBanner
        title="Har du en opgave, der ikke er nævnt her?"
        description="Vi hjælper med mange typer mindre grave- og anlægsarbejder. Ring til Jonas på 42 79 63 01 for en uforpligtende snak om dit projekt."
        primaryBtnText="Kontakt os i dag"
        primaryBtnLink="/kontakt"
      />
    </div>
  )
}
